<template>
  <div class="c-alarm" @keydown.esc="$refs.filialsettingspopover.$emit('close')">

    <button :id="`position-alarm-${postCode}-${cellIndex}`" class="c-alarm-button">
      <svg width="2" height="13" viewBox="0 0 2 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L1 7M1 11L1 12" stroke="#c91512" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <b-popover
      v-if="postCode !== 'driver' && Number(countWorkers) > 0"
      id="position-alarm-popover"
      ref="filialsettingspopover"
      placement="bottomright"
      triggers="click blur hover"
      :target="`position-alarm-${postCode}-${cellIndex}`"
    >
      <svg
        class="b-popover-warning"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
        <circle cx="7" cy="10" r="1" fill="#FF238D" />
        <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
      </svg>
      <div class="b-popover-text">
        <p>За должностью закреплены сотрудники.</p>
        <a class="b-popover-text-link" @click="goToEmployeesTable(postCode)">Посмотреть связанных сотрудников</a>
      </div>
      <svg
        class="b-popover-close"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6045 10.6087C10.2154 10.9977 9.58272 10.9958 9.19126 10.6043L3.53712 4.95155C3.14565 4.56008 3.14367 3.92737 3.5327 3.53835C3.92172 3.14932 4.55443 3.1513 4.9459 3.54277L10.6 9.19551C10.9915 9.58698 10.9935 10.2197 10.6045 10.6087Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 3.54158C10.2212 3.15011 9.58849 3.14813 9.19947 3.53716L3.53718 9.19945C3.14816 9.58847 3.15014 10.2212 3.54161 10.6127C3.93307 11.0041 4.56579 11.0061 4.95481 10.6171L10.6171 4.95478C11.0061 4.56576 11.0041 3.93305 10.6127 3.54158Z"
          fill="#8E9CBB"
        />
      </svg>
    </b-popover>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import ItemsModal from "@/pages/positions/items-modal";

export default {
  name: "c-alarm",

  components: {
    "c-button": Button,
    "m-items": ItemsModal,
  },

  props: ["postCode", "countWorkers", "cellIndex"],

  data() {
    return {
      isShowModalRemove: false,
    };
  },

  methods: {
    openModalRemove() {
      this.isShowModalRemove = true;
    },

    closeModalRemove() {
      this.isShowModalRemove = false;
    },

    goToEmployeesTable(code) {
      window.open(
        `/?r=redesign#/employees/employees-list?sortBy=created&sortType=desc&posts_global=${code}&posts_global_filterType=list&posts_global_searchType=1`,
        "_blank",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-alarm {
  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    margin: 0;
    border: 0;
    background: transparent;

    & > svg {
      margin-right: 10px;
    }
  }

  &-close {
    position: absolute;
    cursor: pointer;
    right: 12px;
    top: 14px;
  }

}
</style>
